{
  "name": "@geoman-io/leaflet-geoman-free",
  "version": "2.19.0",
  "description": "A Leaflet Plugin For Editing Geometry Layers in Leaflet 1.0",
  "keywords": [
    "leaflet",
    "geoman",
    "polygon management",
    "geometry editing",
    "map data",
    "map overlay",
    "polygon",
    "geojson",
    "leaflet-draw",
    "data-field-geojson",
    "ui-leaflet-draw"
  ],
  "files": [
    "dist/leaflet-geoman.js",
    "dist/leaflet-geoman.min.js",
    "dist/leaflet-geoman.css",
    "dist/leaflet-geoman.d.ts",
    "dist/leaflet-geoman.js.map",
    "dist/leaflet-geoman.css.map"
  ],
  "main": "dist/leaflet-geoman.js",
  "module": "dist/leaflet-geoman.js",
  "types": "dist/leaflet-geoman.d.ts",
  "exports": {
    ".": {
      "types": "./dist/leaflet-geoman.d.ts",
      "import": "./dist/leaflet-geoman.js",
      "require": "./dist/leaflet-geoman.js",
      "default": "./dist/leaflet-geoman.js"
    },
    "./dist/leaflet-geoman.css": "./dist/leaflet-geoman.css"
  },
  "dependencies": {
    "@turf/boolean-contains": "^7.3.1",
    "@turf/kinks": "^7.3.1",
    "@turf/line-intersect": "^7.3.1",
    "@turf/line-split": "^7.3.1",
    "lodash": "4.17.21",
    "polyclip-ts": "^0.16.8"
  },
  "devDependencies": {
    "@types/leaflet": "^1.9.21",
    "@vitest/coverage-v8": "^4.0.15",
    "cross-env": "^10.1.0",
    "cypress": "^15.7.1",
    "esbuild": "^0.27.1",
    "eslint": "9.39.1",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-cypress": "5.2.0",
    "eslint-plugin-import": "2.32.0",
    "husky": "^9.1.7",
    "leaflet": "1.9.4",
    "lint-staged": "^16.2.7",
    "prettier": "3.7.4",
    "prosthetic-hand": "1.3.1",
    "typescript": "^5.9.3",
    "vitest": "^4.0.15"
  },
  "peerDependencies": {
    "leaflet": "^1.2.0"
  },
  "engines": {
    "node": ">=18.0.0"
  },
  "scripts": {
    "start": "npm run dev",
    "dev": "cross-env DEV=true node bundle.mjs",
    "build": "node bundle.mjs",
    "test": "cypress run --browser chrome",
    "test:unit": "vitest run",
    "test:unit:watch": "vitest",
    "test:unit:coverage": "vitest run --coverage",
    "test:all": "npm run test:unit && npm run test",
    "cypress": "cypress open",
    "prepare": "npm run build && husky",
    "eslint-check": "eslint --print-config . | eslint-config-prettier-check",
    "eslint": "eslint \"{src,demo}/**/*.js\" --fix ",
    "prettier": "prettier --write \"{src,demo}/**/*.{js,css}\" --log-level=warn",
    "lint": "npm run eslint && npm run prettier",
    "typecheck": "tsc --noEmit"
  },
  "repository": {
    "type": "git",
    "url": "git://github.com/geoman-io/leaflet-geoman.git"
  },
  "author": {
    "name": "Geoman.io",
    "email": "sales@geoman.io",
    "url": "http://geoman.io"
  },
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/geoman-io/leaflet-geoman/issues"
  },
  "homepage": "https://geoman.io",
  "prettier": {
    "trailingComma": "es5",
    "tabWidth": 2,
    "semi": true,
    "singleQuote": true
  },
  "lint-staged": {
    "*.js": "eslint \"{src,demo}/**/*.js\" --fix",
    "*.{js,css,md}": "prettier --write \"{src,demo}/**/*.{js,css}\""
  }
}
